<template>
  <div id="payment" class="section">
    <h1 class="pagetitle">支払い情報管理</h1>
    <div class="columns">
      <div class="column">
        <b-tabs class="tab" type="is-toggle" v-model="activeTab">
          <b-tab-item class="tab__item" label="支払い方法">
            <PaymentMethods />
          </b-tab-item>
          <b-tab-item label="支払い履歴">
            <PaymentHistory />
          </b-tab-item>
        </b-tabs>
      </div>
    </div>
  </div>
</template>
<script>
import PaymentHistory from '@/components/PaymentHistory';
import PaymentMethods from '@/components/PaymentMethods';

export default {
  name: 'Payment',
  components: { PaymentHistory, PaymentMethods },
  data() {
    return {
      activeTab: 0
    };
  }
};
</script>

<style lang="scss">
@import '../assets/scss/payment.scss';
</style>
